import { RelodeApiError, createError } from "@relode/core";
import * as React from "react";

import { jobs } from "../../../../shared/backend/controllers";
import { creators, JobSearchActionTypes } from "./jobSearchActionTypes";
import { SearchCriteria } from "./jobSearchState";

export const useJobSearchActions = (
    dispatch: React.Dispatch<JobSearchActionTypes>
) => {
    const search = async (criteria: SearchCriteria) => {
        dispatch(creators.search(criteria));
        try {
            const results = await jobs.jobService.search(criteria);
            dispatch(creators.searchSuccess(results));
        } catch (err) {
            if (err instanceof RelodeApiError) {
                if (err.isAbort()) return;
                if (err.isClientError()) {
                    dispatch(creators.searchFailure(err));
                    return;
                }
            }
            throw createError(err, "jobs.jobSearchActions.search");
        }
    };

    const searchText = (searchText: string) =>
        dispatch(creators.searchText(searchText));

    const navigate = (direction: "prev" | "next") =>
        dispatch(creators.navigate(direction));

    const filterSingle = (
        id: string,
        name: string,
        item?: { label: string; value: string }
    ) => dispatch(creators.filterSingle(id, name, item));

    const filterMultiple = (
        id: string,
        name: string,
        category?: string,
        item?: { label: string; value: string }
    ) => dispatch(creators.filterMultiple(id, name, category, item));

    const searchBySelectedFilters = (
        searchText?: string,
        distance?: number,
        locationId?: number,
        locationName?: string
    ) =>
        dispatch(
            creators.searchBySelectedFilters(
                searchText,
                distance,
                locationId,
                locationName
            )
        );

    const sort = (field: string) => dispatch(creators.sort(field));

    const sortMobile = (field: string, direction: SortDir) =>
        dispatch(creators.sortMobile(field, direction));

    const clearErrors = () => dispatch(creators.clearErrors());

    return {
        search,
        searchText,
        navigate,
        filterSingle,
        filterMultiple,
        searchBySelectedFilters,
        sort,
        sortMobile,
        clearErrors,
        selectAllJobs: () => dispatch(creators.selectAllJobs()),
        deselectAllJobs: () => dispatch(creators.deselectAllJobs()),
        setJobChecked: (jobId: number | string) =>
            dispatch(creators.setJobChecked(+jobId)),
        setJobUnchecked: (jobId: number | string) =>
            dispatch(creators.setJobUnchecked(+jobId)),
    };
};

export type JobSearchActions = ReturnType<typeof useJobSearchActions>;
